import { NonResidentObject, NonResidentShortObject } from 'models/nonresident'
import { PaginationParams, PaginationResponse } from 'models/pagination'
import { IStatistic } from 'models/statistic'

import { clientApi } from './clientApi'

export type NonResidentParams = {
  status: string
  region_id: string
  start_date: string
  end_date: string
  consultant: string
  region: string
  branch: string
  limit?: number
  pan: string
  search: string
  supervisor?: string
  use_verification_date: boolean
}

export interface NonResidentReworkDTO {
  controller_comment: string
}

export const NonResidentApi = {
  getNonResidents(params: PaginationParams) {
    return clientApi.get<PaginationResponse<NonResidentShortObject>>(
      '/web/non_resident/',
      {
        params,
      },
    )
  },
  getNonResidentsStatistics(params: PaginationParams) {
    return clientApi.get<IStatistic[]>('/web/non_resident/statistics/', {
      params,
    })
  },
  getNonResidentById(id: number) {
    return clientApi.get<NonResidentObject>(`/web/non_resident/${id}/`)
  },
  approveNonResident(id: number) {
    return clientApi.put(`/web/non_resident/${id}/approve/`)
  },
  refuseNonResident(id: number) {
    return clientApi.put(`/web/non_resident/${id}/refuse/`)
  },
  reworkNonResident(id: number, body: NonResidentReworkDTO) {
    return clientApi.put(`/web/non_resident/${id}/rework/`, body)
  },
  downloadNonResidents(params: Partial<NonResidentParams>) {
    return clientApi.get('/web/non_resident/excel/', {
      responseType: 'blob',
      params,
    })
  },
  downloadNonResidentsBonus(params: Partial<NonResidentParams>) {
    return clientApi.get('/web/non_resident/bonus_excel/', {
      responseType: 'blob',
      params,
    })
  },
  downloadNonResidentsForMonth(params: Partial<NonResidentParams>) {
    return clientApi.get('/web/non_resident/excel_for_month/', {
      responseType: 'blob',
      params,
    })
  },
}
